import React, { useState } from "react";
import { Space } from "antd";
import Layout from "../../components/Layout/index";
import Tab1 from "../../components/DashboardRoFood/Tab-1/index";
import Tab3 from "../../components/DashboardRoFood/Tab-3/index";
import Tab2 from "../../components/DashboardRoFood/Tab-2/index";

export default function DashboardRoFood() {
	const [activeTab, setActiveTab] = useState("tab1");

	const renderContent = () => {
		switch (activeTab) {
			case "tab1":
				return <Tab1 />;
			case "tab2":
				return <Tab2 />;
			case "tab3":
				return (
					<>
						<Tab3 />
					</>
				);

			default:
				return null;
		}
	};

	return (
		<Layout>
			<div className="m-5">
				<h1 className="text-2xl font-bold">RoFood</h1>
				<Space style={{ marginBottom: 16 }} className="mt-10">
					<button
						className={`${
							activeTab === "tab1" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold `}
						onClick={() => setActiveTab("tab1")}
					>
						Sotuv ko'rsatkichlari
					</button>
					<button
						className={`${
							activeTab === "tab2" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold ml-3`}
						onClick={() => setActiveTab("tab2")}
					>
						Moliyaviy ko'rsatkichlar
					</button>
					<button
						className={`${
							activeTab === "tab3" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold ml-3`}
						onClick={() => setActiveTab("tab3")}
					>
						Moliyaviy hisobotlar
					</button>
				</Space>
				<div className="mt-10">{renderContent()}</div>
			</div>
		</Layout>
	);
}
